<mat-checkbox color="primary" [formControl]="bodyControls.retentAnlegen">Retent anlegen</mat-checkbox>
<mat-checkbox
	color="primary"
	[formControl]="this.bodyControls.anGerichtSenden"
	(change)="toggleGerichtControl($event.checked)"
	data-test-id="an-gericht-senden">
	Akte, beglaubigte Registerabschrift und Schiffspapiere an das aufnehmende Gericht senden
</mat-checkbox>
@if (bodyControls.gericht.enabled) {
	<mat-form-field appearance="outline" data-test-id="amtsgericht">
		<mat-label>Amtsgericht</mat-label>
		<input type="text" matInput [matAutocomplete]="auto" [formControl]="bodyControls.gericht" />
		<mat-autocomplete #auto="matAutocomplete">
			@for (option of amtsgerichtOptions; track option) {
				<mat-option [value]="option">{{ option }}</mat-option>
			}
		</mat-autocomplete>
	</mat-form-field>
}
<mat-checkbox color="primary" [formControl]="bodyControls.umEintragungsnachrichtBitten">
	um Eintragungsnachricht wird gebeten
</mat-checkbox>
